export const GET_MAPPER_MODELS = "GET_MAPPER_MODELS";
export const SET_MAPPER_MODELS = "SET_MAPPER_MODELS";
export const GET_MAPPER_MODEL_ID = "GET_MAPPER_MODEL_ID";
export const SET_MAPPER_MODEL_ID = "SET_MAPPER_MODEL_ID";
export const POST_MAPPER_FILES = "POST_MAPPER_FILES";
export const GET_MAPPER_FILES = "GET_MAPPER_FILES";
export const DELETE_MAPPER_FILES = "DELETE_MAPPER_FILES";
export const SET_MAPPER_FILES = "SET_MAPPER_FILES";
export const SET_MAPPER_FILES_LOADER = "SET_MAPPER_FILES_LOADER";
export const SET_MAPPER_DATA = "SET_MAPPER_DATA";
export const POST_MAPPER_BASIC_MAPPER = "POST_MAPPER_BASIC_MAPPER";
export const SHOW_LOAD_BASIC_MAPPER = "SHOW_LOAD_BASIC_MAPPER";
export const SUCCESS_MAPPER_BASIC_MAPPER = "SUCCESS_MAPPER_BASIC_MAPPER";
export const POST_MAPPER_VALIDATION = "POST_MAPPER_VALIDATION";
export const SET_MAPPER_VALIDATION = "SET_MAPPER_VALIDATION";
export const SET_MAPPER_VALIDATION_SUCCESS = "SET_MAPPER_VALIDATION_SUCCESS";
export const SHOW_VALIDATION_PROCESS = "SHOW_VALIDATION_PROCESS";
export const HIDE_VALIDATION_PROCESS = "HIDE_VALIDATION_PROCESS";
export const SET_ERROR_MAPPER = "SET_ERROR_MAPPER";

export const GET_MAPPER_TEMPLATES = "GET_MAPPER_TEMPLATES";
export const SET_MAPPER_TEMPLATES = "SET_MAPPER_TEMPLATES";
export const GET_MAPPER_TEMPLATE = "GET_MAPPER_TEMPLATE";
export const SET_MAPPER_TEMPLATE = "SET_MAPPER_TEMPLATE";
export const POST_MAPPER_TEMPLATE = "POST_MAPPER_TEMPLATE";
export const DELETE_MAPPER_TEMPLATE = "DELETE_MAPPER_TEMPLATE";
export const PATCH_MAPPER_TEMPLATE = "PATCH_MAPPER_TEMPLATE";
export const SET_TEMPLATE_ERROR = "SET_TEMPLATE_ERROR";
